// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const timeEntrySchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  name: z.string().max(500),
  taskId: z.string().max(100),
  startAt: z.string().max(200).datetime(),
  endAt: z.string().max(200).optional(),
  duration: z.number().min(0).max(999999).optional(),
  categoryId: z.string().max(100).optional(),
  tagIds: z.array(z.string()).optional(),
  archived: z.boolean(),
  tenantId: z.string().max(100).optional(),
})

export type TimeEntryInput = z.infer<typeof timeEntrySchema>
